.col {
  font-family: inherit;
  font-size: inherit;
}
